import { formatDateForDisplay } from 'helpers/dateTimes';

// Formats et libellés partagés par les deux cartes de la section facturation.

// Catégories de lignes renvoyées par le service (`InvoiceLineCategory`) : mêmes libellés dans la synthèse
// par canal (Consommation) et dans le document (Facture potentielle).
export const INVOICE_CATEGORY_LABELS: Record<string, string> = {
    consumption: 'Consommation & minimum (RME)',
    subvention: 'Subventions',
    ritual: 'Rituels',
    organizationPayment: 'Badge Pro',
    shrinkage: 'Démarque',
    freefood: 'Freefood',
};

const percentFormatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 });
const integerFormatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

export const formatVatRate = (taxRate?: number | null): string =>
    taxRate === undefined || taxRate === null ? '' : `TVA ${percentFormatter.format(taxRate * 100)} %`;

export const formatCount = (count: number): string => integerFormatter.format(count);

export const formatPeriod = (startDate: string, endDate: string): string =>
    `Période du ${formatDateForDisplay(startDate)} au ${formatDateForDisplay(endDate)}`;
